import { types, flow, cast } from "mobx-state-tree"
import { inventoryBusiness } from "businesses/inventory-business"

const InventoryStore = types
  .model({
    data: types.optional(types.frozen(), []),
    productInformation: types.maybeNull(types.frozen()),
    productMovement: types.maybeNull(types.frozen()),
    isLoading: types.maybeNull(types.boolean),
    customFilters: types.maybeNull(types.frozen()),
    selectedId: types.maybeNull(types.string, ""),
    searchText: types.maybeNull(types.string, ""),
    forceReload: types.maybeNull(types.boolean, false),
  })
  .views(self => ({
    get isArchivalSearch() {
      return self.customFilters?.archival_search || false
    },
  }))
  .actions(self => ({
    setForceReload() {
      self.forceReload = !self.forceReload
    },
    setData(data) {
      self.data = data
    },
    setSelectedId(id) {
      self.selectedId = id
    },
    setSearchText(val) {
      self.searchText = val
    },
    setCustomFilters(data) {
      self.customFilters = cast(data)
    },
  }))
  .actions(self => ({
    resetData() {
      self.productInformation = null
      self.selectedId = ""
      self.data = []
      self.searchText = ""
      self.customFilters = null
    },
    loadData: flow(function* (showLoading = true) {
      if (!self.searchText) {
        self.setData([])
        return
      }

      if (showLoading) self.isLoading = true
      const searchParams = {
        ...(self.customFilters || {}),
      }
      const data = yield inventoryBusiness.getData(searchParams)
      self.setData(data)
      if (showLoading) self.isLoading = false
    }),
    loadDetailData: flow(function* (productId) {
      self.selectedId = productId

      self.isLoading = true
      const searchParams = {
        product_code: decodeURIComponent(productId),
        id: 0,
        archival_search: self.isArchivalSearch,
      }
      const info = yield inventoryBusiness.getProductDetails(searchParams)
      if (info) self.productInformation = { ...info, dgGoods: Boolean(info.dg_volume && info.un_number) && info.dg_volume > 0 }

      const movement = yield inventoryBusiness.getProductMovement({
        product_code: searchParams.product_code,
      })
      self.productMovement = movement || []

      self.isLoading = false
    }),
    addOrUpdateData: flow(function* (productItem) {
      const result = self.selectedId ? yield inventoryBusiness.updateData(productItem) : yield inventoryBusiness.addData(productItem)
      return result
    }),
    uploadData: flow(function* (data) {
      return yield inventoryBusiness.uploadData(data)
    }),
  }))
export default InventoryStore
